import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

interface Props {
  children: React.ReactNode;
  href: string;
  className?: string;
}
function WhatsappButton({ children, href, className = '' }: Props) {
  return (
    <a
      href={href}
      target="_blank"
      className={`bg-white flex gap-1 justify-center text-xs text-[#39AE41] font-medium items-center border border-[#39AE41] py-3 rounded whitespace-nowrap lg:px-3 lg:py-4 lg:font-semibold ${className}`}
      rel="noreferrer"
    >
      {children}
    </a>
  );
}

export default WhatsappButton;
